// Reading FastAPI error bodies.
//
// `detail` is usually a string, but some routes send an object with a machine
// `code` and a human `message` (the publish gate does), and validation errors
// send a list of { msg } entries.

export function errorDetailMessage(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail;
  if (detail && typeof detail === 'object' && !Array.isArray(detail)) {
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
  }
  if (Array.isArray(detail)) {
    const messages = detail.map((item) => item?.msg).filter((msg) => typeof msg === 'string' && msg);
    if (messages.length) return messages.join('; ');
  }
  return err?.message || fallback;
}

/**
 * The publish gate: 409 with detail { code: 'needs_review', needsReviewCount, message }
 * while questions still carry an AI-guessed answer nobody has reviewed.
 * Returns the count (at least 1) when the error is that gate, otherwise null.
 */
export function needsReviewCount(err) {
  if (err?.response?.status !== 409) return null;
  const detail = err.response.data?.detail;
  if (!detail || typeof detail !== 'object' || detail.code !== 'needs_review') return null;
  const n = Number(detail.needsReviewCount);
  return Number.isFinite(n) && n > 0 ? n : 1;
}
